import { keyframes, css } from "styled-components";
import colors from "constants/colors";

const shine = keyframes`
    0% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 10% 50%;
    }
`;

export function skeleton(color) {
    let mainColor;
    let secondaryColor;

    if (!color) {
        mainColor = colors.peach;
        secondaryColor = colors.peachLight;
    } else if (color === "gray") {
        mainColor = colors.lightGrey;
        secondaryColor = colors.athensGrey;
    }

    return css`
        background-color: var(--color-peach);
        background-image: linear-gradient(
            to right,
            ${mainColor},
            ${mainColor},
            ${mainColor},
            ${secondaryColor},
            ${mainColor},
            ${mainColor},
            ${mainColor}
        );
        background-size: 400% 400%;

        animation: ${shine} 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    `;
}
